const ytDeferred = $.Deferred()
window.onYouTubeIframeAPIReady = function () {
  ytDeferred.resolve(window.YT)
}

var ytInterval = setInterval(() => {
  if (window.YT && window.YT.loaded) {
    ytDeferred.resolve(window.YT)
    clearInterval(ytInterval)
  }
}, 300);

(function ($) {
  /* ---- video youtube ---- */
  // This code loads the Youtube IFrame Player API code asynchronously.
  const youtubeApiTag = document.createElement('script')

  youtubeApiTag.src = 'https://www.youtube.com/iframe_api'
  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(youtubeApiTag, firstScriptTag)

  ytDeferred.done((YT) => {
    $.fn.initVideoYoutube($('.portlet-video--youtube .video__container'))
    $('.portlet-video--youtube').parents('.split-deck .content-container, .generic-deck').addClass('video-c')
  })

  $.fn.isInViewport = function () {
    const elementTop = $(this).offset().top
    const elementBottom = elementTop + $(this).outerHeight()

    const viewportTop = $(window).scrollTop()
    const viewportBottom = viewportTop + $(window).height()

    return elementBottom > viewportTop && elementTop < viewportBottom
  }

  $.fn.initVideoYoutube = function (videoEls) {
    // Expand video to fit full width of the container
    function updateContainerHeight($iframeContainer, aspectRatio) {
      const blockWidth = $iframeContainer.width()
      const viewportHeight = window.innerHeight
      let newVideoHeight = blockWidth * aspectRatio

      if (newVideoHeight > viewportHeight) { // Making sure that expanded video fits user's screen/window
        newVideoHeight = viewportHeight
      }

      $iframeContainer.animate({
        height: newVideoHeight
      }, 600)
    }

    function setContainerHeight(event, $iframeContainer) {
      const iframe = event.target.getIframe()
      const aspectRatio = iframe.height / iframe.width

      updateContainerHeight($iframeContainer, aspectRatio)

      $('html, body').animate({
        scrollTop: $iframeContainer.offset().top
      }, 500)

      $(window).on('resize', () => {
        const $videoPoster = $iframeContainer.find('.src-img')

        if (!$videoPoster.length) {
          updateContainerHeight($iframeContainer)
        }
      })
    }

    let isMobile = false
    let AUTOPLAY = 1
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
      isMobile = true
      AUTOPLAY = 0
    }

    function countVideoProgress(percent, $element) {

      let progressBarWidth = percent * $element.width() / 100;
      $element.find('div').css({ width: progressBarWidth });

    }

    videoEls.each(function (i) {
      const $thisEl = $(this)
      const playerId = `player-${i}`
      const videoId = $thisEl.attr('id')
      let $progressBar
      let player
      let youtubeReady = false

      $thisEl.attr('id', `${videoId}-${i}`) // assigning unique ID for casese whene two identical videos are used on the same page

      function loadAndSetupYoutube() {
        // Create the player container
        const playerContainer = $('<div/>', {
          id: playerId
        })

        let SHOWINFO = 0
        let MUTE = 0
        let PLAYSINLINE = 0
        let playerProgressBarInterval

        if ($thisEl.hasClass('show-mobile-title') && isMobile) {
          SHOWINFO = 1
        }
        if ($thisEl.data('mute') === 1) {
          MUTE = 1
        }
        if($thisEl.data('inlineVideo') === 1) {
          PLAYSINLINE = 1
        }

        const posterHtml = $thisEl.html()

        // Print the playercontainer
        $thisEl.html(playerContainer).addClass('loaded')

        if($thisEl.data('muteBtn') === 1) {
          $thisEl.append('<div class="mute-btn"><span class="muted"><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><g><path d="M7.353 11.98l1.48 1.479V9a.5.5 0 0 1 1 0v4.863a.833.833 0 0 1-1.422.588l-1.764-1.764a.5.5 0 1 1 .706-.707zM4.46 5.5l3.952-3.951a.833.833 0 0 1 1.421.589V5a.5.5 0 1 1-1 0V2.541L5.02 6.354a.5.5 0 0 1-.353.146H2.333a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5H4a.5.5 0 0 1 0 1H2.333A1.5 1.5 0 0 1 .833 9V7a1.5 1.5 0 0 1 1.5-1.5H4.46zm-2.106 9.52a.5.5 0 0 1-.708-.707L14.98.98a.5.5 0 0 1 .707.707L2.354 15.02z"/></g></svg></span><span class="unmuted"><svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M723.028 980.477l-20.178-47.018c158.949-68.216 261.655-224.156 261.655-397.276 0-173.121-102.706-329.062-261.655-397.277l20.178-47.018c87.068 37.366 160.678 99.005 212.87 178.252 52.188 79.237 79.772 171.233 79.772 266.043s-27.583 186.804-79.77 266.041c-52.194 79.248-125.804 140.887-212.872 178.253zm-259.74-72.622c-16.789 0-32.665-6.671-44.705-18.782L229.446 699.975H85.326c-34.947 0-63.378-28.43-63.378-63.378V409.82c0-34.947 28.431-63.379 63.378-63.379h144.12L418.639 157.29c11.983-12.055 27.86-18.726 44.648-18.726 34.946 0 63.378 28.431 63.378 63.38v642.532c.001 34.948-28.43 63.38-63.377 63.38zM85.326 397.608c-6.506 0-12.213 5.707-12.213 12.213v226.777c0 6.505 5.707 12.213 12.213 12.213h165.31l204.179 204.134c2.42 2.435 5.409 3.744 8.473 3.744 6.506 0 12.213-5.707 12.213-12.214V201.942c0-6.506-5.707-12.214-12.213-12.214-3.064 0-6.053 1.31-8.416 3.688L250.636 397.608H85.326zM662.635 840.52l-19.827-47.168C743.96 750.837 811.92 647.488 811.92 536.182c0-111.307-67.96-214.657-169.112-257.171l19.826-47.169c59.466 24.995 109.918 67.263 145.902 122.237 35.685 54.52 54.55 117.49 54.55 182.103s-18.865 127.581-54.55 182.102c-35.984 54.973-86.436 97.242-145.901 122.237zm-60.5-140.548l-19.175-47.435c44.967-18.177 76.374-66.024 76.374-116.356 0-50.786-31.32-98.6-76.166-116.273l18.76-47.603c32.133 12.664 59.543 35.431 79.267 65.839 18.897 29.132 29.304 63.948 29.304 98.036 0 34.526-10.139 68.364-29.32 97.851-19.627 30.17-46.96 52.974-79.044 65.941z"/></svg></span></div>')
        }

        // This function creates an <iframe> (and YouTube player)
        // after the API code downloads.
        player = new YT.Player(playerId, {
          videoId,
          host: 'https://www.youtube-nocookie.com',
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange
          },
          playerVars: {
            autohide: 1,
            // enablejsapi: 1,
            autoplay: AUTOPLAY,
            controls: 2,
            modestbranding: 1,
            showinfo: SHOWINFO,
            rel: 0,
            mute: MUTE,
            playsinline: PLAYSINLINE
          }
        })

        // The Youtube Iframe API will call this function when the video player is ready.
        function onPlayerReady(event) {
          if (isMobile === true) {
            return
          }

          const $iframeContainer = $thisEl.closest('.content-block')

          if($thisEl.data('adjustHeight') !== 0) {
            setContainerHeight(event, $iframeContainer)
          }
        }

        function onPlayerStateChange(event) {
          const $iframeContainer = $thisEl.closest('.content-block')

          if (isMobile && event.data == YT.PlayerState.BUFFERING) {
            if($thisEl.data('adjustHeight') !== 0) {
              setContainerHeight(event, $iframeContainer)
            }
          }

          // Shrink the block to its initial height and show poster after video stops
          if (event.data == YT.PlayerState.ENDED) {

            youtubeReady = false
            $thisEl.addClass('video-ended')

            if($thisEl.parents('.newsroom-main').length) {
              dataLayer.push({
                'videoName': player.getVideoData().title,
                'event': 'videoEnded'
              });
            }

            if (!isMobile) {
              event.target.destroy()
            }

            if($thisEl.data('adjustHeight') !== 0) {
              const curHeight = $iframeContainer.height()

              $iframeContainer.css('height', 'auto')

              const autoHeight = $iframeContainer.height()

              $iframeContainer.height(curHeight).animate({
                height: autoHeight
              }, 400, () => {
                $iframeContainer.removeAttr('style')
              })
            }

            if (!isMobile) {
              $thisEl.hide().html(posterHtml).fadeIn('slow')
            }
          }
          if (event.data === YT.PlayerState.PLAYING && $thisEl.data('progressBar') === 1) {

            $thisEl.parent().append('<div class="video-progress-bar"><div></div></div>')

            $progressBar = $thisEl.parent().find('.video-progress-bar')

            youtubeReady = true
            $thisEl.removeClass('video-ended')

            if($thisEl.parents('.newsroom-main').length) {
              dataLayer.push({
                'videoName': player.getVideoData().title,
                'event': 'videoStarted'
              });
            }

            if($thisEl.data('progressBar') === 1) {
              $progressBar.show();
            }

            let playerTotalTime = player.getDuration();

            playerProgressBarInterval = setInterval(function() {

              let playerCurrentTime = player.getCurrentTime();
              let playerTimeDifference = (playerCurrentTime / playerTotalTime) * 100;

              countVideoProgress(playerTimeDifference, $progressBar);

            }, 50);

          } else {
            clearInterval(playerProgressBarInterval);
            if($thisEl.data('progressBar') === 1) {
              $progressBar.find('div').removeAttr('style');
              $progressBar.hide();
            }
          }
        }
        $thisEl.off().on('click', '.mute-btn', (e) => {
          e.stopPropagation();
          e.preventDefault();

          if(player.isMuted()) {
            player.unMute()
            $(e.currentTarget).find('.muted').hide()
            $(e.currentTarget).find('.unmuted').show()
          } else {
            player.mute()
            $(e.currentTarget).find('.muted').show()
            $(e.currentTarget).find('.unmuted').hide()
          }

        })

      }

      if (!$thisEl.hasClass('loaded')) {
        if (isMobile) {
          loadAndSetupYoutube()
        } else {
          if($thisEl.data('loadOnViewport') !== 1) {
            $(document).delegate(`#${videoId}-${i}`, 'click', loadAndSetupYoutube)
          }
        }
      }

      $('.newsroom-collage-media').on('click', (e) => {
        if($(e.currentTarget).find($thisEl).hasClass('video-ended')) {
          e.stopPropagation()
          e.preventDefault()
          loadAndSetupYoutube()
        }
      })

      $(window).on('scroll', () => {
        if ($thisEl.isInViewport() && !$thisEl.hasClass('started') && $thisEl.data('loadOnViewport') === 1) {
          $thisEl.addClass('started');
          loadAndSetupYoutube()
        }
        if(youtubeReady && $thisEl.data('loadOnViewport') === 1 && !isMobile) {
          if($thisEl.isInViewport()) {
            $thisEl.removeClass('paused')
            player.playVideo()
          } else {
            $thisEl.addClass('paused')
            player.pauseVideo()
          }
        }

      })
    })
  }
}(jQuery))
